export default __webpack_public_path__ + "static/media/banner-03.179d30d3.png";